'use client';

import { event_payment_failed } from '@/utils/gtm';
import { useEffect } from 'react';
import NextLink from '../next-link';

const NoItems = ({ icon, title, description, button, buttonLink, order }) => {
  useEffect(() => {
    if (order) {
      event_payment_failed({
        payment_type: order?.payment?.method,
        reason: order?.status_histories?.[0]?.comment || 'Order not successful',
        transaction_id: order?.increment_id,
        value: order?.grand_total,
      });
    }
  }, [order]);
  return (
    <div className='flex min-h-[60vh] flex-col items-center justify-center gap-6 max-md:gap-4'>
      {icon}
      <h2 className='mt-4 text-2xl font-semibold max-md:text-base'>{title}</h2>
      <p className='max-w-96 text-center text-[#74787C] max-md:text-xs'>
        {description}
      </p>
      <NextLink
        href={buttonLink}
        className='bg-primary w-60 rounded-md p-2 text-center font-bold text-nowrap text-white uppercase max-md:w-50 max-md:text-sm'
      >
        {button}
      </NextLink>
    </div>
  );
};

export default NoItems;
